<template>
    <div class="admin_main_wrapper">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <uploadLandingFileDialog :settings="uploadLandingFileDialogSettings" v-if="uploadLandingFileDialogSettings.show"></uploadLandingFileDialog>
        <b-list-group class="links_list" id="places_list">
        <b-button variant="secondary" block @click="showUploadLandingFileDialog" style="width: 300px;">
            Upload file
        </b-button>
            <b-list-group-item v-for="(item, index) in items" :key="index" :id="`link-${index}`"
                               class="link-item">
                <div class="link_header">
                    <div class="created_">{{item.created_at | moment("MMM D YYYY, h:mm a")}}</div>
                </div>
                <div class="link_header">
                    <span class="small_lbl">File name: </span><div class="link_id">{{item.file_name}}</div>
                </div>
                <div class="place_uid">
                    <span class="small_lbl">Full url:</span> <input type="text" :value="item.full_url" :id="`file_link_full-${item.id}`">
                    <button @click="copyLink(`file_link_full-${item.id}`)">Copy</button>
                </div>
                <div class="place_uid" v-if="item.short_url">
                    <span class="small_lbl">Short url:</span> <input type="text" :value="item.short_url" :id="`file_link_short-${item.id}`">
                    <button @click="copyLink(`file_link_short-${item.id}`)">Copy</button>
                </div>

            </b-list-group-item>
            <infinite-loading :identifier="infiniteItems" @infinite="loadLinks">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
            </infinite-loading>
        </b-list-group>

    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import moment from 'moment'
import InfiniteLoading from "vue-infinite-loading";
import customModalDialog from '@/components/widgets/customModalDialog';
import errorMixin from '@/mixins/errorMixin';
import uploadLandingFileDialog from '@/components/widgets/uploadLandingFileDialog';
import adminPageMixin from "@/mixins/adminPageMixin";


export default {
    name: 'landingFiles',
    mixins: [errorMixin, adminPageMixin,],
    components: {
        InfiniteLoading,
        customModalDialog,
        uploadLandingFileDialog,
    },

    data() {
        return {
            infiniteItems: 0,
            page: 1,
            items: [],
            loadingAction: false,
            customModalSettings: {},
            uploadLandingFileDialogSettings: {},
        }
    },

    props: ['infinity'],

    watch: {
        infinity(val) {
            this.page = 1
            this.infiniteItems += 1
        }
    },

    computed: {
        ...mapState({
            accounts: state => state.closeAccount.accounts
        })
    },
    mounted() {
        this.initAdminPage()
        this.refreshAll()
    },
    methods: {

        ...mapActions({
            getLandingFiles: 'question/getLandingFiles',
        }),

        ...mapMutations({
            setMessageModel: 'setMessageModel',
        }),

        async refreshAll() {

        },

        async loadLinks(stateInf) {
            try {
                this.loadingAction = true
                const response = await this.getLandingFiles({
                    page: this.page
                })
                if(this.page == 1) {
                    this.items = []
                }
                this.page += 1;
                this.items = response.collection
                if (stateInf) {
                    if (this.items.length === 100) {
                        stateInf.loaded();
                    } else {
                        stateInf.complete();
                    }
                }
            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.loadingAction = false
            }
        },

        copyLink(itemId) {
            const field = document.getElementById(itemId)
            field.select();
            try {
                return document.execCommand("copy");
            } catch (ex) {
                this.setMessageModel({
                    msg: 'Failed to copy. Please use CTRL+C to copy',
                    duration: 1000
                })
            } finally {

            }
        },
        showUploadLandingFileDialog() {
            this.uploadLandingFileDialogSettings = {
                show: true
            }
        },


    }

}
</script>

<style scoped>
.created_ {
    font-size: 12px;
}

.small_lbl {
    font-size: 14px;
    color: #a2a2a2;
}

.links_list {
    max-height: calc(100vh - 62px);
    overflow: auto;
    margin-bottom: 0;
    padding-bottom: 5em;
}

.link_header {
    display: flex;
    flex-direction: row;
}

</style>
